import script from "./ConnectedInvoices.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectedInvoices.vue?vue&type=script&setup=true&lang=js"

import "./ConnectedInvoices.vue?vue&type=style&index=0&id=79944c6f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79944c6f"]])

export default __exports__